/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewManifest
 */
export interface NewManifest {
    /**
     * 
     * @type {string}
     * @memberof NewManifest
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof NewManifest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof NewManifest
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof NewManifest
     */
    masterAwb?: string;
    /**
     * 
     * @type {string}
     * @memberof NewManifest
     */
    awbReference?: string;
    /**
     * 
     * @type {Date}
     * @memberof NewManifest
     */
    dateReceived?: Date;
    /**
     * 
     * @type {string}
     * @memberof NewManifest
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof NewManifest
     */
    createdOn?: Date;
    /**
     * 
     * @type {string}
     * @memberof NewManifest
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof NewManifest
     */
    courierId?: number;
    /**
     * Scan-in lifecycle status: open or closed
     * @type {string}
     * @memberof NewManifest
     */
    scanStatus?: string;
    /**
     * Scheduled flight/shipment departure date
     * @type {Date}
     * @memberof NewManifest
     */
    departureDate?: Date;
}

/**
 * Check if a given object implements the NewManifest interface.
 */
export function instanceOfNewManifest(value: object): value is NewManifest {
    return true;
}

export function NewManifestFromJSON(json: any): NewManifest {
    return NewManifestFromJSONTyped(json, false);
}

export function NewManifestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewManifest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'masterAwb': json['masterAwb'] == null ? undefined : json['masterAwb'],
        'awbReference': json['awbReference'] == null ? undefined : json['awbReference'],
        'dateReceived': json['dateReceived'] == null ? undefined : (new Date(json['dateReceived'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdOn': json['createdOn'] == null ? undefined : (new Date(json['createdOn'])),
        'status': json['status'] == null ? undefined : json['status'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'scanStatus': json['scanStatus'] == null ? undefined : json['scanStatus'],
        'departureDate': json['departureDate'] == null ? undefined : (new Date(json['departureDate'])),
    };
}

export function NewManifestToJSON(json: any): NewManifest {
    return NewManifestToJSONTyped(json, false);
}

export function NewManifestToJSONTyped(value?: NewManifest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'masterAwb': value['masterAwb'],
        'awbReference': value['awbReference'],
        'dateReceived': value['dateReceived'] == null ? undefined : ((value['dateReceived']).toISOString()),
        'createdBy': value['createdBy'],
        'createdOn': value['createdOn'] == null ? undefined : ((value['createdOn']).toISOString()),
        'status': value['status'],
        'courierId': value['courierId'],
        'scanStatus': value['scanStatus'],
        'departureDate': value['departureDate'] == null ? undefined : ((value['departureDate']).toISOString()),
    };
}

